export const siteStats = [
  { id: 'board', label: '索引板块', value: '12', unit: '个' },
  { id: 'flash', label: '收录快讯', value: '8,432', unit: '条' },
  { id: 'today', label: '今日更新', value: '156', unit: '条' },
  { id: 'buzz', label: '热评讨论', value: '2.6', unit: '万' },
];

export const navBoards = [
  { id: 'board-index', label: '板块索引' },
  { id: 'focus', label: '本周焦点' },
  { id: 'flash', label: '最新快讯' },
  { id: 'ranking', label: '热度榜' },
  { id: 'buzz', label: '热评互动' },
  { id: 'tags', label: '趋势标签' },
];

export const tickerItems = [
  '快讯 · 某综艺录制现场片段引发讨论，相关词条三小时内冲上热搜第 4 位',
  '快讯 · 影视剧组路透曝光，番位安排成为新一波讨论焦点',
  '快讯 · 直播圈头部主播深夜连麦，评论区互动量破 12 万',
  '快讯 · 音乐节临时调整节目单，官方回应已同步至公告区',
  '快讯 · 电竞转会期传闻汇总，多支战队阵容出现变动',
];

export const quickBoards = [
  { id: 'qb-1', name: '热门事件', icon: 'ri-fire-line' },
  { id: 'qb-2', name: '人物黑料', icon: 'ri-user-unfollow-line' },
  { id: 'qb-3', name: '影视剧瓜', icon: 'ri-film-line' },
  { id: 'qb-4', name: '综艺现场', icon: 'ri-mic-line' },
  { id: 'qb-5', name: '网红主播', icon: 'ri-live-line' },
  { id: 'qb-6', name: '电竞圈', icon: 'ri-gamepad-line' },
];

export const boardIndex = [
  {
    id: 'b-1',
    name: '热门事件',
    icon: 'ri-fire-line',
    desc: '全网高热事件集中索引，按热度与时间双维度归并，追更首选入口。',
    count: '1,286',
    tags: ['热搜跟进', '实时更新'],
    tone: 'primary',
  },
  {
    id: 'b-2',
    name: '人物黑料',
    icon: 'ri-user-unfollow-line',
    desc: '人物相关瓜料归档区，按时间线整理已被公开讨论的内容与后续进展。',
    count: '2,140',
    tags: ['归档整理', '进展追踪'],
    tone: 'primary',
  },
  {
    id: 'b-3',
    name: '影视剧瓜',
    icon: 'ri-film-line',
    desc: '剧组路透、番位争议、片场花絮，影视项目相关讨论一站式汇总。',
    count: '968',
    tags: ['路透', '番位'],
    tone: 'accent',
  },
  {
    id: 'b-4',
    name: '综艺现场',
    icon: 'ri-mic-line',
    desc: '节目录制花絮与争议片段索引，按节目与期数分类，便于对照回顾。',
    count: '742',
    tags: ['录制花絮', '名场面'],
    tone: 'accent',
  },
  {
    id: 'b-5',
    name: '网红主播',
    icon: 'ri-live-line',
    desc: '直播圈动态汇总，连麦、带货、账号变动等信息持续收录更新。',
    count: '1,053',
    tags: ['直播动态', '带货'],
    tone: 'secondary',
  },
  {
    id: 'b-6',
    name: '音乐圈',
    icon: 'ri-music-2-line',
    desc: '新歌发布、音乐节现场、合作传闻等音乐相关内容的分区索引。',
    count: '612',
    tags: ['新歌', '现场'],
    tone: 'secondary',
  },
  {
    id: 'b-7',
    name: '体育圈',
    icon: 'ri-basketball-line',
    desc: '赛事动态、人员转会与场外讨论的整理区，赛程期间更新频率较高。',
    count: '534',
    tags: ['转会', '赛事'],
    tone: 'accent',
  },
  {
    id: 'b-8',
    name: '电竞圈',
    icon: 'ri-gamepad-line',
    desc: '战队阵容、转会期传闻与赛场争议，按联赛分区整理归档。',
    count: '488',
    tags: ['转会期', '赛场'],
    tone: 'primary',
  },
  {
    id: 'b-9',
    name: '时尚圈',
    icon: 'ri-vip-diamond-line',
    desc: '活动造型、品牌合作与红毯讨论汇总，按活动场次整理索引。',
    count: '376',
    tags: ['红毯', '造型'],
    tone: 'secondary',
  },
  {
    id: 'b-10',
    name: '情感八卦',
    icon: 'ri-heart-3-line',
    desc: '情感相关讨论的公开内容索引，标注时间线与后续澄清进展。',
    count: '421',
    tags: ['时间线', '澄清'],
    tone: 'accent',
  },
  {
    id: 'b-11',
    name: '商业职场',
    icon: 'ri-briefcase-line',
    desc: '商业合作、公司动态与职场话题的整理区，适合按行业浏览。',
    count: '259',
    tags: ['合作', '公司动态'],
    tone: 'secondary',
  },
  {
    id: 'b-12',
    name: '校园生活',
    icon: 'ri-school-line',
    desc: '校园相关讨论与公共话题索引，按地区与院校分类便于定位。',
    count: '198',
    tags: ['公共话题', '地区'],
    tone: 'primary',
  },
];

export const focusTopic = {
  week: '第 38 周',
  title: '本周焦点：多起事件同步发酵，板块更新频率创近期新高',
  desc: '本周共有 46 条快讯进入热门事件索引，其中影视剧瓜与综艺现场两个板块贡献了近半数的更新量。编辑组已按事件时间线重新整理归档，并补齐了此前的后续进展记录，方便按板块回看完整脉络。',
  points: [
    '影视剧瓜板块单周新增 18 条，创下该板块设立以来的最高周更新量。',
    '综艺现场板块的争议片段索引新增"原片对照"说明，看之前先看时间线。',
    '热度榜前 10 名中有 6 条来自人物黑料板块，互动量集中在评论区。',
  ],
  meta: [
    { id: 'fm-1', label: '本周更新', value: '46 条' },
    { id: 'fm-2', label: '涉及板块', value: '9 个' },
    { id: 'fm-3', label: '热评互动', value: '8,712' },
  ],
};

export const newsFeed = [
  {
    id: 'n-1',
    time: '10:24',
    date: '今天',
    board: '影视剧瓜',
    title: '某剧组路透片段流出，番位安排成为新一轮讨论焦点',
    summary: '相关词条在短时间内进入热搜前列，评论区出现两派观点，编辑组已整理时间线。',
    heat: '9.4万',
    comments: '3,182',
    fresh: true,
  },
  {
    id: 'n-2',
    time: '09:51',
    date: '今天',
    board: '综艺现场',
    title: '综艺录制花絮曝光，现场片段引发节目组回应',
    summary: '节目组在官方账号发布说明，本条已同步更新至对应板块的进展记录中。',
    heat: '7.8万',
    comments: '2,406',
    fresh: true,
  },
  {
    id: 'n-3',
    time: '09:12',
    date: '今天',
    board: '网红主播',
    title: '直播圈连麦互动量破 12 万，评论区氛围持续升温',
    summary: '双方在直播中就此前讨论作出回应，相关片段已被整理进入互动氛围区。',
    heat: '6.2万',
    comments: '1,988',
    fresh: true,
  },
  {
    id: 'n-4',
    time: '08:40',
    date: '今天',
    board: '电竞圈',
    title: '转会期传闻汇总更新，多支战队阵容出现变动',
    summary: '本期新增 5 条待确认传闻，均已标注来源属性，未确认内容不进入热度榜。',
    heat: '5.6万',
    comments: '1,742',
    fresh: false,
  },
  {
    id: 'n-5',
    time: '22:18',
    date: '昨天',
    board: '音乐圈',
    title: '音乐节临时调整节目单，官方同步发布公告',
    summary: '调整原因与后续安排已在公告区说明，本条为昨日更新中互动量最高的一条。',
    heat: '5.1万',
    comments: '1,563',
    fresh: false,
  },
  {
    id: 'n-6',
    time: '21:02',
    date: '昨天',
    board: '时尚圈',
    title: '品牌活动造型讨论升温，同场多位艺人造型被对比',
    summary: '本场活动共整理 14 组造型记录，相关讨论集中在评论区氛围板块。',
    heat: '4.3万',
    comments: '1,204',
    fresh: false,
  },
  {
    id: 'n-7',
    time: '19:36',
    date: '昨天',
    board: '人物黑料',
    title: '人物相关瓜料归档更新，补齐此前缺失的后续进展',
    summary: '本次归档覆盖 3 个此前未完整记录的时间节点，方便按时间线回看。',
    heat: '8.9万',
    comments: '2,864',
    fresh: false,
  },
  {
    id: 'n-8',
    time: '17:05',
    date: '昨天',
    board: '体育圈',
    title: '赛事争议判罚讨论汇总，官方已发布说明',
    summary: '争议片段与官方说明已一并收录，本条进入本周热度榜第 8 位。',
    heat: '3.9万',
    comments: '986',
    fresh: false,
  },
];

export const hotRanking = [
  { id: 'r-1', board: '人物黑料', title: '人物相关瓜料归档集中更新，时间线补齐后讨论再度升温', heat: 986420, delta: 'up' },
  { id: 'r-2', board: '影视剧瓜', title: '剧组路透片段流出，番位安排成为新一轮讨论焦点', heat: 941880, delta: 'up' },
  { id: 'r-3', board: '综艺现场', title: '综艺录制现场片段曝光，节目组发布官方说明', heat: 878350, delta: 'up' },
  { id: 'r-4', board: '网红主播', title: '直播圈连麦互动量刷新记录，评论区热度居高不下', heat: 802140, delta: 'flat' },
  { id: 'r-5', board: '电竞圈', title: '转会期传闻汇总更新，多支战队阵容出现变动', heat: 764020, delta: 'up' },
  { id: 'r-6', board: '音乐圈', title: '音乐节节目单临时调整，官方同步发布公告说明', heat: 699580, delta: 'down' },
  { id: 'r-7', board: '时尚圈', title: '品牌活动造型讨论升温，同场艺人造型被集中对比', heat: 641300, delta: 'flat' },
  { id: 'r-8', board: '体育圈', title: '赛事争议判罚讨论汇总，官方已发布正式说明', heat: 596740, delta: 'down' },
  { id: 'r-9', board: '情感八卦', title: '情感话题时间线整理完成，澄清内容已同步归档', heat: 512860, delta: 'up' },
  { id: 'r-10', board: '商业职场', title: '商业合作传闻整理，双方暂未作出公开回应', heat: 468920, delta: 'flat' },
];

export const buzzComments = [
  {
    id: 'c-1',
    user: '瓜田里的猹',
    meta: '热门事件 · 3 分钟前',
    text: '时间线整理得很清楚，比零散刷片段高效多了，先收藏再按板块慢慢看。',
    likes: 2841,
    replies: 126,
    top: true,
  },
  {
    id: 'c-2',
    user: '前排小板凳',
    meta: '综艺现场 · 12 分钟前',
    text: '原片对照这个说明建议其他板块也补上，不然只看片段真的很容易被带偏。',
    likes: 1963,
    replies: 88,
    top: false,
  },
  {
    id: 'c-3',
    user: '理性吃瓜选手',
    meta: '人物黑料 · 26 分钟前',
    text: '希望未确认的内容继续标注清楚来源属性，这一点做得比别的地方靠谱。',
    likes: 1520,
    replies: 214,
    top: true,
  },
  {
    id: 'c-4',
    user: '追更不迷路',
    meta: '影视剧瓜 · 41 分钟前',
    text: '番位那块终于有人按时间线捋了，评论区两派吵得我都看晕了。',
    likes: 1184,
    replies: 73,
    top: false,
  },
  {
    id: 'c-5',
    user: '夜猫子观察员',
    meta: '电竞圈 · 1 小时前',
    text: '转会期传闻汇总做成长图就更好了，手机刷起来会方便很多。',
    likes: 862,
    replies: 45,
    top: false,
  },
  {
    id: 'c-6',
    user: '路过顺手一瓜',
    meta: '时尚圈 · 2 小时前',
    text: '这个站最舒服的就是一页能看到所有板块，不用来回跳，跟进更新很快。',
    likes: 654,
    replies: 31,
    top: false,
  },
];

export const trendTags = [
  { id: 't-1', name: '番位争议', count: 1286 },
  { id: 't-2', name: '录制花絮', count: 1104 },
  { id: 't-3', name: '时间线整理', count: 968 },
  { id: 't-4', name: '连麦互动', count: 842 },
  { id: 't-5', name: '转会期', count: 736 },
  { id: 't-6', name: '红毯造型', count: 628 },
  { id: 't-7', name: '音乐节现场', count: 574 },
  { id: 't-8', name: '官方回应', count: 512 },
  { id: 't-9', name: '热搜跟进', count: 486 },
  { id: 't-10', name: '直播带货', count: 402 },
  { id: 't-11', name: '赛事争议', count: 368 },
  { id: 't-12', name: '品牌合作', count: 296 },
];

export const updateRhythm = [
  { id: 'u-1', slot: '09:00', label: '早间速览', desc: '汇总隔夜新增快讯与热搜变动' },
  { id: 'u-2', slot: '13:00', label: '午间跟进', desc: '补充上午事件的后续进展记录' },
  { id: 'u-3', slot: '18:00', label: '晚间汇总', desc: '整理当日高互动内容的评论区动向' },
  { id: 'u-4', slot: '22:30', label: '当日归档', desc: '按板块完成当日索引归档与标注' },
];

export const footerColumns = [
  {
    id: 'f-1',
    title: '热门板块',
    links: ['热门事件索引', '人物黑料归档', '影视剧瓜汇总', '综艺现场快讯'],
  },
  {
    id: 'f-2',
    title: '兴趣分区',
    links: ['网红主播', '电竞圈', '音乐圈', '时尚圈'],
  },
  {
    id: 'f-3',
    title: '浏览方式',
    links: ['按热度排序', '按时间排序', '按板块筛选', '只看今日更新'],
  },
  {
    id: 'f-4',
    title: '站点说明',
    links: ['资源汇总说明', '内容标注规则', '板块更新节奏', '互动区规范'],
  },
];